/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/qaPhoneControlInventory.ts
 * FILE_ID: JOBHUB-QA-PHONE-INV-001
 * PURPOSE: One id per desktop QA control that must stay reachable on phone.
 */
export const QA_PHONE_CONTROLS = {
  quoteSheet: 'qa-phone-quote-sheet',
  area: 'qa-phone-area',
  checklist: 'qa-phone-checklist',
  floorGroup: 'qa-phone-floor-group',
  allChecklists: 'qa-phone-all-checklists',
  select: 'qa-phone-select',
  density: 'qa-phone-density',
  selectPhotos: 'qa-phone-select-photos',
  undo: 'qa-phone-undo',
  redo: 'qa-phone-redo',
  refresh: 'qa-phone-refresh',
  modeBuild: 'qa-phone-mode-build',
  modeRun: 'qa-phone-mode-run',
  modeItp: 'qa-phone-mode-itp',
  addArea: 'qa-phone-add-area',
  addChecklist: 'qa-phone-add-checklist',
  templates: 'qa-phone-templates',
  addProduct: 'qa-phone-add-product',
  standardChecks: 'qa-phone-standard-checks',
  addRow: 'qa-phone-add-row',
  aiGenerate: 'qa-phone-ai-generate',
  rowActions: 'qa-phone-row-actions',
  tableColumns: 'qa-phone-table',
  buildCards: 'qa-phone-build-cards',
  buildViewToggle: 'qa-phone-build-view-toggle',
  productSearch: 'qa-phone-product-search',
  hold: 'qa-phone-hold',
  parked: 'qa-phone-parked',
  signoff: 'qa-phone-signoff',
  progress: 'qa-phone-progress',
  areaWorkStatus: 'qa-phone-area-work-status',
  inProgressBadge: 'qa-phone-in-progress',
  verifyChecklist: 'qa-phone-verify-checklist',
  verifyCheck: 'qa-phone-verify-check',
  filterPills: 'qa-phone-filter-pills',
  statusChip: 'qa-phone-status-chip',
  itpStatusButtons: 'qa-phone-itp-status',
  photo: 'qa-phone-photo',
  attach: 'qa-phone-attach',
  requirements: 'qa-phone-requirements',
  criteria: 'qa-phone-criteria',
  notes: 'qa-phone-notes',
  photoGallery: 'qa-phone-photo-gallery',
  evidence: 'qa-phone-evidence',
  notesThread: 'qa-phone-notes-thread',
  reading: 'qa-phone-reading',
  changeBanner: 'qa-phone-change-banner',
  exportItp: 'qa-phone-export-itp',
  saveItpLibrary: 'qa-phone-save-itp-library',
  itpLibrary: 'qa-phone-itp-library',
  pack: 'qa-phone-pack',
  editChecklist: 'qa-phone-edit-checklist',
  deleteChecklist: 'qa-phone-delete-checklist',
  assign: 'qa-phone-assign',
  move: 'qa-phone-move',
  rename: 'qa-phone-rename',
  delete: 'qa-phone-delete',
  unlock: 'qa-phone-unlock',
  openItp: 'qa-phone-open-itp',
  showAll: 'qa-phone-show-all',
  sectionCollapse: 'qa-phone-section-collapse',
  newChecklistDraft: 'qa-phone-new-checklist',
  prepare: 'qa-phone-prepare',
  titleSelect: 'qa-phone-title-select',
  titleAdd: 'qa-phone-title-add',
  titleTemplates: 'qa-phone-title-templates',
  titleHome: 'qa-phone-title-home',
  jobSection: 'qa-phone-job-section',
} as const

export type QaPhoneControlId = (typeof QA_PHONE_CONTROLS)[keyof typeof QA_PHONE_CONTROLS]

export const QA_PHONE_CONTROL_IDS = Object.values(QA_PHONE_CONTROLS)
